var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "search", attrs: { id: "vue-search" } }, [
    _c(
      "span",
      {
        class: ["search__icon", { "search__icon--loading": _vm.showLoader }],
        attrs: { "aria-hidden": "true" },
      },
      [
        _c(
          "svg",
          {
            staticClass: "search__icon-glass",
            attrs: {
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
            },
          },
          [
            _c("circle", {
              attrs: {
                cx: "7",
                cy: "7",
                r: "5.5",
                stroke: "currentColor",
                "stroke-width": "1.5",
              },
            }),
            _vm._v(" "),
            _c("line", {
              attrs: {
                x1: "11.5",
                y1: "11.5",
                x2: "15",
                y2: "15",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "svg",
          {
            staticClass: "search__icon-spinner",
            attrs: {
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
            },
          },
          [
            _c("circle", {
              attrs: {
                cx: "7",
                cy: "7",
                r: "5.5",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-dasharray": "26 9",
              },
            }),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c("input", {
      ref: "search",
      staticClass: "c-textbox c-textbox--communities",
      attrs: {
        "data-cy": "search-community",
        type: "text",
        placeholder: _vm.placeholder,
      },
      domProps: { value: _vm.search },
      on: {
        input: (ev) => (_vm.search = ev.target.value),
        keyup: (event) => _vm.getInput(true, event),
      },
    }),
    _vm._v(" "),
    _c(
      "span",
      {
        class: ["search__clear", _vm.showReset ? "search__active" : ""],
        attrs: { "aria-label": "Clear search" },
        on: { click: _vm.clearInput },
      },
      [
        _c(
          "svg",
          {
            attrs: {
              width: "14",
              height: "14",
              viewBox: "0 0 14 14",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M1 1L13 13M13 1L1 13",
                stroke: "currentColor",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
              },
            }),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", {
      staticClass: "c-community__search-message",
      domProps: { innerHTML: _vm._s(_vm.searchMeta) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }